import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

// Hook
import useMessage from "hooks/useMessage";

// Slice
import { uiActions, selectShowModalSpinner } from "stores/slice/ui";

// UI
import SpinnerForModal from "ui/SpinnerForModal";

// Component
import Button from "components/Button";
import ModalContainer from "components/ModalContainer";
import MessageBoxGroup from "components/MessageBoxGroup";

const DeleteModal = props => {
  const { t } = useTranslation();

  const {
    modalStatus,
    selectedOrg,
    selectedId,
    title,
    description,
    changeModalStatus,
    execute,
    successCallback
  } = props;

  const dispatch = useDispatch();
  const showModalSpinner = useSelector(selectShowModalSpinner);

  const {
    messages,
    messagesType,
    resetMessages,
    setErrorMessage
  } = useMessage();

  const handleDelete = async () => {
    dispatch(uiActions.showModalSpinner());

    try {
      const response = await execute(selectedOrg.id, [selectedId]);

      if (response.error) {
        throw response.error;
      }

      dispatch(uiActions.hideModalSpinner());
      resetMessages();
      changeModalStatus(modalStatus.delete.type, false);
      successCallback();
    } catch (error) {
      setErrorMessage(error.code);
      dispatch(uiActions.hideModalSpinner());
    }
  }

  useEffect(() => {
    if (modalStatus.delete.status) {
      resetMessages();
    }
  }, [modalStatus.delete.type])

  return (
    <ModalContainer
      modalWidthType="modal-500px"
      openModal={modalStatus.delete.status}
      closeModal={() => changeModalStatus('delete', false)}
    >
      {showModalSpinner && <SpinnerForModal />}
      <div className="header">
        <div className="title">{t(title)}</div>
      </div>
      <div className='body'>
        <MessageBoxGroup
          messages={messages}
          ErrorMessagesType={messagesType.error.server}
          onClose={resetMessages}
        />
        <div className='mb-3 modal-warning-color'>{t(description)}</div>
      </div>
      <div className="footer">
        <Button
          label="bafd7322c6"
          className="btn-cancel"
          onClick={() => changeModalStatus('delete', false)}
        />
        <Button
          label="93cba07454"
          className="btn-delete"
          onClick={handleDelete}
        />
      </div>
    </ModalContainer>
  );
};

export default DeleteModal;
